:host {
  contain: content;
  display: flex;
  flex-direction: column;
  padding: 16px 0px 10px 0px;

  overflow: hidden;
  color: var(--theme-primary-text);
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  width: 307px;
  border-bottom: 1px solid var(--theme-light-border);
}

:host(:first-of-type) {
  padding-top: 0px;
}
/* I supply my own padding if I'm an only child, see the .single rule in aha-chart-tooltop.css */
:host(:only-child) {
  padding: 16px;
  padding-bottom: 10px;
}

#body {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#header {
  display: flex;
  gap: 6px;
  align-items: center;
  margin-bottom: 12px;

  color: var(--theme-tertiary-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px;
}

#icon {
  align-self: center;
  font-size: 9px;
  height: 17px;
  line-height: 17px;
  text-align: center;
  width: 17px;
  border-radius: 17px;
  flex: 0 1 17px;
  background-color: var(--theme-blue-text);
  color: var(--theme-light-text);
}

#type {
  text-transform: capitalize;
}

::slotted([slot='header-right']) {
  margin-left: auto;
}

::slotted([slot='footer']) {
  display: flex;
  gap: 6px;
  padding: 6px 0px;

  color: var(--theme-secondary-text);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
}
